import { app, Component } from 'apprun';
import { __, lang } from './Txlat';

const search = () => {
  const url = new URL(window.location.href);
  const keyword = (document.querySelector('input[name="keyword"]') as HTMLInputElement).value;
  const name = (document.querySelector('input[name="name"]') as HTMLInputElement).value;
  const specialities = document.getElementsByName('specialty[]')[0] as HTMLSelectElement;

  let specialitiesStr;
  for (let i = 0; i < specialities.selectedOptions.length; i++) {
    if (specialities.selectedOptions[i].value) {
      if (specialitiesStr) {
        specialitiesStr += ',' + specialities.selectedOptions[i].value.toLowerCase();
      } else {
        specialitiesStr = specialities.selectedOptions[i].value.toLowerCase();
      }
    }
  }

  const last_keyword_search = url.searchParams.get('keyword');
  const last_Name_search = url.searchParams.get('name');
  const last_Specialities = url.searchParams.getAll('specialty[]');

  let last_specialitiesStr;
  for (let i = 0; i < last_Specialities.length; i++) {
    if (last_Specialities[i]) {
      if (last_specialitiesStr) {
        last_specialitiesStr += ',' + last_Specialities[i].toLowerCase();
      } else {
        last_specialitiesStr = last_Specialities[i].toLowerCase();
      }
    }
  }

  if (keyword !== last_keyword_search || name !== last_Name_search || specialitiesStr !== last_specialitiesStr) {
    url.searchParams.set('keyword', keyword);
    url.searchParams.set('name', name);

    url.searchParams.delete('specialty[]');

    for (let i = 0; i < specialities.selectedOptions.length; i++) {
      if (specialities.selectedOptions[i].value) {
        url.searchParams.append('specialty[]', specialities.selectedOptions[i].value.toLowerCase());
      }
    }

    window.history.pushState({}, '', url.href);
    app.run('#');
  }

  return false;
};

export default class extends Component {

  view = () => {
    const params = new URLSearchParams(location.search);
    const keyword = params.get('keyword') ? params.get('keyword').trim() : '';
    const name = params.get('name') ? params.get('name').trim() : '';
    // const specialty = params.get('specialty') ? params.get('specialty').trim() : '';
    const allsSpecialties = params.getAll('specialty[]');

    return (
      <div class="container" >
        <form autocomplete="off" onsubmit={search}>
          <div class="d-flex flex-lg-row flex-column">
            <div class="m-1" style="flex:1">
              <div class="form-group"><input type="text" name="name" class="form-control m-1" value={name} placeholder={__('"First Name Last Name"')} /></div>
            </div>
            <div class="m-1" style="flex:1">
              <div class="form-group"><input name="keyword" type="text" class="form-control m-1" value={keyword} placeholder={__('"City", "Postal Code"')} /></div>
            </div>
            {/* <input name="specialty" type="text" class="form-control m-1" value={specialty} placeholder={__('"Specialty"')} /> */}

            <div class="m-1" style="flex:1">
              <div class="form-group">
                <select name="specialty[]" data-size="5" class="selectpicker form-control m-1"
                  title={__('Specialty')} data-live-search="true" data-selected-text-format="count > 1"
                  data-actions-box="true" multiple data-select-all-text={__('Select All')}
                  data-deselect-all-text={__('Deselect All')} data-count-selected-text={'{0} ' + __('Specialties')}
                  data-none-results-text={`${__('No results matched')} {0}`} data-container="body">

                  <option data-ref="agricultural" value={__('Agricultural')} selected={allsSpecialties?.indexOf('agricultural') >= 0 ? 'selected' : ''}>{__('Agricultural')}</option>
                  <option data-ref="business" value={lang.get() !== 'fr' ? 'Restaurant business,Small bussiness' : 'Restaurants'} selected={allsSpecialties?.indexOf(lang.get() !== 'fr' ? 'Restaurant business,Small bussiness' : 'Restaurants'.toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Business')}</option>
                  <option data-ref="hotels/motels" value={lang.get() !== 'fr' ? 'Hotels,Bed & Breakfast,Bed and Breakfast' : 'Hôtels'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Hotels,Bed & Breakfast,Bed and Breakfast' : 'Hôtels').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Hotels/Motels')}</option>

                  <option data-ref="industrial" value={lang.get() !== 'fr' ? 'Industrial' : 'Bien industriel'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Industrial' : 'Bien industriel').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Industrial')}</option>

                  <option data-ref="investment" value={lang.get() !== 'fr' ? 'Investment,Small Investment' : 'Bien d\'investissement'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Investment, Small Investment' : 'Bien d\'investissement').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Investment')}</option>

                  <option data-ref="land" value={lang.get() !== 'fr' ? 'Development,Land Development,Vacant Land' : 'Développement,Terrain à développer,Terrain vacant'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Development,Land Development,Vacant Land' : 'Développement,Terrain à développer,Terrain vacant').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Land')}</option>

                  <option data-ref="multi-family" value={lang.get() !== 'fr' ? 'Apartment buildings,Multi-Residential' : 'Propriété à revenu (Appartements),Immeuble à logements multiples'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Apartment buildings,Multi-Residential' : 'Propriété à revenu (Appartements),Immeuble à logements multiples').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Multi Family')}</option>

                  <option data-ref="retail" value={lang.get() !== 'fr' ? 'Retail' : 'Commerce de détail'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Retail' : 'Commerce de détail').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Retail')}</option>
                  <option data-ref="office" value={lang.get() !== 'fr' ? 'Office' : 'Bureau'} selected={allsSpecialties?.indexOf((lang.get() !== 'fr' ? 'Office' : 'Bureau').toLocaleLowerCase()) >= 0 ? 'selected' : ''}>{__('Office')}</option>

                </select>
              </div>
            </div>

            <div class="m-1">
              <div class="form-group">
                <button type="submit" class="btn btn-search btn-secondary m-1">{__('Search')}</button>
              </div>
            </div>
          </div>
        </form >
      </div >
    );
  };
}
